"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionallyDisabledCellComponent = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var CellStyle = {
    opacity: widgets_1.TabStyles.Opacity.Disabled,
};
var testId = 'disabled-cell-wrapper';
function ConditionallyDisabledCellComponent(CellFormatter, isDisabled) {
    return React.createFactory(/** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            var rowData = this.props.row.data;
            if (isDisabled(rowData)) {
                return React.createElement("div", { style: CellStyle, "data-tb-test-id": testId },
                    React.createElement(CellFormatter, __assign({}, this.props)));
            }
            else {
                return React.createElement("div", { "data-tb-test-id": testId },
                    React.createElement(CellFormatter, __assign({}, this.props)));
            }
        };
        return class_1;
    }(React.Component)));
}
exports.ConditionallyDisabledCellComponent = ConditionallyDisabledCellComponent;
//# sourceMappingURL=ConditionallyDisabledCell.js.map